import { render, staticRenderFns } from "./desktop-pagename.vue?vue&type=template&id=27af8fa9&scoped=true&"
import script from "./desktop-pagename.vue?vue&type=script&lang=ts&"
export * from "./desktop-pagename.vue?vue&type=script&lang=ts&"
import style0 from "./desktop-pagename.vue?vue&type=style&index=0&id=27af8fa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27af8fa9",
  null
  
)

component.options.__file = "desktop-pagename.vue"
export default component.exports